// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___2GDYy","plus":"styles__plus___2U025","clip":"styles__clip___pfH3I"};